// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.76-TSS-3082-mcastro-BUG-Isolated-Campaign-Not-Downloading-To-Excel.0";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
